/**
 *
 * Styles for AdvancedSettings
 *
 */

import styled from "styled-components";
import { Headline } from "root/libs/ui-components/src";
import { DhlText } from "@dhl-official/react-library";
import { breakpoints } from "root/libs/ui-styleguide/src";

export const AdvancedSettingsWrapper = styled.fieldset`
  .dhl-cj-main & {
    display: block;
    margin: 0 var(--dui-size-space-7x) var(--dui-size-space-5x) !important;
    padding-top: var(--dui-size-space-9x) !important;
    border-top: var(--dui-size-width-border-xs) solid var(--dui-color-gray-600) !important;
    width: 100%;

    @media screen and (min-width: ${breakpoints.tablet}) {
      margin: var(--dui-size-space-10x) 0 0 !important;
      border-top: none !important;
      padding-top: 0 !important;
    }
  }

  @media print {
    border-top: 0 !important;
    padding-top: 0px;
  }
`;

export const StyledHeadline = styled(Headline)`
  margin-bottom: 0;
`;

export const AdvancedSettingsCheckboxWrapper = styled.div`
  @media screen and (min-width: ${breakpoints.tablet}) {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;

    .checkbox {
      margin-right: var(--gaq-size-space-30px);
      padding: var(--gaq-size-space-9px) 0;

      &:last-child {
        margin-right: 0;
      }
    }
  }

  @media print {
    display: flex;
    flex-direction: row;
  }
`;

export const CheckboxContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  padding: var(--gaq-size-space-9px) var(--dui-size-space-10x)
    var(--gaq-size-space-9px) 0;
  align-items: center;

  .iconWrapper {
    margin-top: var(--gaq-size-space-9px);
  }
  & dhl-checkbox > dhl-selection-control > div.is-disabled {
    opacity: 0.5;
  }

  @media print {
    padding: 0px;
  }

  label > input {
    /*! @noflip */
    left: -9999px;
    /*! @noflip */
    right: unset;
    position: absolute;
  }
`;

export const ToolTipText = styled(DhlText)`
  & > *:is(p, span) {
    margin-bottom: ${(props) =>
      props.isParagraph ? "var(--dui-size-space-5x)" : 0} !important;
  }
`;
